<style lang="less" scoped>
</style>

<template>
  <div>
    <router-link
      :to="route.path"
      v-for="route in expressRoutes"
      :key="route.name"
      ><van-button type="default">{{
        route.meta.title
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in configRoutes"
      :key="route.name"
      ><van-button type="default">{{
        $t(route.meta.title)
      }}</van-button></router-link
    >
    <br /><br />
    <router-link :to="route.path" v-for="route in adRoutes" :key="route.name"
      ><van-button type="default">{{
        $t(route.meta.title)
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in apartmentRoutes"
      :key="route.name"
      ><van-button type="default">{{
        route.meta.title
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in agreementRoutes"
      :key="route.name"
      ><van-button type="default">{{
        $t(route.meta.title)
      }}</van-button></router-link
    >
    <br /><br />
    <router-link :to="equipmentPairRoutes.path"
      ><van-button type="default">{{$t(equipmentPairRoutes.meta.title)}}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in downloadRoutes"
      :key="route.name"
      ><van-button type="default">{{
        route.meta.title
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in networkCardRoutes"
      :key="route.name"
      ><van-button type="default">{{
        route.meta.title
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in storageRoutes"
      :key="route.name"
      ><van-button type="default">{{
        route.meta.title
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in medicalRoutes"
      :key="route.name"
      ><van-button type="info" class="margin">{{
        $t(route.meta.title)
      }}</van-button></router-link
    >
    <br /><br />
    <router-link
      :to="route.path"
      v-for="route in trafficRoutes"
      :key="route.name"
      ><van-button type="info" class="margin">{{
        $t(route.meta.title)
      }}</van-button></router-link
    >
    <a href="https://beian.miit.gov.cn">浙ICP备18048214号-5</a>
  </div>
</template>

<script>
import { Button } from "vant";
import configRoutes from "@/router/flash-config";
import expressRoutes from "@/router/express";
import adRoutes from "@/router/ad";
import apartmentRoutes from "@/router/apartment";
import agreementRoutes from "@/router/agreement";
import equipmentPairRoutes from "@/router/equipment-pair";
import downloadRoutes from "@/router/download";
import networkCardRoutes from "@/router/network-card";
import storageRoutes from "@/router/storage";
import medicalRoutes from "@/router/medical";
import trafficRoutes from "@/router/traffic";

export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      configRoutes: configRoutes,
      expressRoutes: expressRoutes,
      adRoutes: adRoutes,
      apartmentRoutes: apartmentRoutes,
      agreementRoutes: agreementRoutes,
      equipmentPairRoutes: equipmentPairRoutes[0],
      downloadRoutes: downloadRoutes,
      networkCardRoutes: networkCardRoutes,
      storageRoutes: storageRoutes,
      medicalRoutes: medicalRoutes,
      trafficRoutes: trafficRoutes,
    };
  },
};
</script>
